import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MasterService } from "@frontend/app/serivces/master.service";
import { Cls_CityData } from "@frontend/app/models/master";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { ToastrService } from "@frontend/app/serivces/toastr.service";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-add-city",
  imports: [CommonModule, SharedModule],
  templateUrl: "./add-city.component.html",
  styleUrl: "./add-city.component.scss",
})
export class AddCityComponent implements OnInit {
  private masterService = inject(MasterService);
  private toastrService = inject(ToastrService);

  private dialogRef = inject(MatDialogRef<AddCityComponent>);
  ngOnInit() {
    this.getRegionList();
  }
  //#region variables
  cityList = new Cls_CityData();
  regionList: any;
  isUserTypeDropdownOpen = false;

  //#endregion

  getRegionList() {
    this.masterService.getRegionList().subscribe((res: any) => {
      const { Table } = res;
      this.regionList = Table.filter((item: any) => item.IsActive);
    });
  }

  onSubmit() {
    const tempModal = new Cls_CityData();
    tempModal.RegionID = this.cityList.RegionID;
    tempModal.CityName = this.cityList.CityName;
    tempModal.IsActive = true;
    this.masterService.addCity(tempModal).subscribe((res: any) => {
      this.toastrService.success("City added successfully");
      this.dialogRef.close(res);
    });
  }
}
